import { h } from 'preact';

import SynopsisEditor from 'components/editor/movies/synopsis/synopsis';

import s from 'components/editor/movies/synopsis/synopsisUniversal.sss';

export default class UniversalSynopsisEditor extends SynopsisEditor {
	s = s;
}
